import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-lease`
let baseUrl1 = `${httpUrl.host}/gy-apartment`

let api = {
  // 获取承租主体列表
  getLeaseList: `${baseUrl1}/lease/getList`,

  // 获取租金分页
  getRentPage: `${baseUrl}/rentManager/getPage`,

  // 获取租金信息
  getRentByCode: `${baseUrl}/rentManager/getByCode`,

  // 修改租金信息
  updateRentByCode: `${baseUrl}/rentManager/updateByCode`,

  // 获取押金分页
  getDepositPage: `${baseUrl}/deposit/getPage`,

  // 获取押金信息
  getDepositByCode: `${baseUrl}/deposit/getByCode`,

  // 修改押金信息
  updateDepositByCode: `${baseUrl}/deposit/updateByCode`,

  // 导出物业费
  exportForRentAndProperty: `${baseUrl}/payItemDetail/exportForRentAndProperty`,

  // 导出保证金
  exportForSecurityDeposit: `${baseUrl}/payItemDetail/exportForSecurityDeposit`,

  // 获取合同分页
  getContractPage: `${baseUrl}/contractManager/getPage`,

  // 获取房间列表
  getRoomInfoList: `${baseUrl1}/roomInfo/getRoomInfoList`,

  // 获取房源详情
  getRoomInfoDetailByCode: `${baseUrl1}/roomInfo/getRoomInfoDetailByCode`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl1}/enterpriseInfo/getEnterpriseList`,

  // 添加合同
  addContract: `${baseUrl}/contractManager/add`,

  // 获取合同详情
  getContractByCode: `${baseUrl}/contractManager/getByCode`,

  // 修改合同
  updateContractByCode: `${baseUrl}/contractManager/updateByCode`,

  // 修改合同状态
  updateStatusByCode: `${baseUrl}/contractManager/updateStatusByCode`,

  // 作废合同
  cancelContractByCode: `${baseUrl}/contractManager/cancel`,

  // 获取跟进人列表
  getYqPersonList: `${baseUrl1}/person/getYqPersonList`,

  // 获取租金明细
  getRentDetail: `${baseUrl}/contractManager/getRentDetail`,

  // 获取物业明细
  getPropertyDetail: `${baseUrl}/contractManager/getPropertyDetail`,

  // 获取费用列表
  getPayItemDetailPage: `${baseUrl}/payItemDetail/getPage`,

  // 获取费用详情
  getPayItemDetailByCode: `${baseUrl}/payItemDetail/getByCode`,

  // 修改费用信息
  updatePayItemDetailByCode: `${baseUrl}/payItemDetail/updateByCode`,

  // 上传pdf
  uploadPdf: `${baseUrl}/upload/uploadPdf`,

  // 上传合同附件
  uploadAttachment: `${baseUrl}/contractManager/uploadAttachment`,

  // 手动处理
  handleDueContractManager: `${baseUrl}/contractManager/handleDue`,

  // 获取合同列表
  getContractTemplateList: `${baseUrl}/contractTemplate/getList`,

  // 生成合同
  downloadContract: `${baseUrl}/contractManager/download`,

  // 合同导入
  importContract: `${baseUrl}/contractManager/import`,

  // 合同导出
  exportContract: `${baseUrl}/contractManager/export`,

  // 合同导入模板
  exportMbUrl: `https://damai-oss.oss-cn-hangzhou.aliyuncs.com/template/contract_import_template%20.xlsx`,

  // 合同保存
  saveContract: `${baseUrl}/contractApprove/save`,

  // 合同修改
  saveToUpdateContract: `${baseUrl}/contractApprove/saveToUpdate`,

  // 合同复制
  saveCopyContract: `${baseUrl}/contractApprove/saveCopyContract`,

  // 合同审批
  passContract: `${baseUrl}/contractManager/passContract`,

  // 合同删除
  deleteContractByCode: `${baseUrl}/contractManager/deleteByCode`,

  // 获取审批人员列表
  getAccountListByCode: `${baseUrl}/contractApprove/getAccountListByCode`,

  // 提交审批
  submitAccount: `${baseUrl}/contractApprove/submit`,

  // 查看退租协议
  getSurrenderContractDetailByContractCode: `${baseUrl}/contractApprove/getSurrenderContractDetailByContractCode`,

  // 查询历史账单
  getListByContractCode: `${baseUrl}/payItemDetail/getListByContractCode`,

  // 退租保存
  saveSurrender: `${baseUrl}/contractApprove/saveSurrender`,

  // 退租待确认保存
  saveSurrenderToUpdate: `${baseUrl}/contractApprove/saveSurrenderToUpdate`,

  // 退租待确认提交审批
  submitSurrender: `${baseUrl}/contractApprove/submitSurrender`,

  // 续租保存
  saveRelet: `${baseUrl}/contractApprove/saveRelet`,

  // 续租待确认保存
  saveReletToUpdate: `${baseUrl}/contractApprove/saveReletToUpdate`,

  // 续租待确认提交审批
  submitRelet: `${baseUrl}/contractApprove/submitRelet`,

  // 换租保存
  saveRentChange: `${baseUrl}/contractApprove/saveRentChange`,

  // 换租修改
  updateRentChange: `${baseUrl}/contractApprove/updateRentChange`,

  // 换租提交审批
  submitRentChange: `${baseUrl}/contractApprove/submitRentChange`,

  // 批量开票
  updatePatchPayItemDetail: `${baseUrl}/payItemDetail/updatePatch`,

  // 手动抄表
  getEnterpriseElectricRetain: `${baseUrl}/contractApprove/getEnterpriseElectricRetain`,

  // ———————————————————————————————— 其他合约 ————————————————————————————
  // 添加其他合同
  saveOtherContractApprove: `${baseUrl}/otherContractApprove/save`,

  // 其他合同分页
  getOtherContractManagerPage: `${baseUrl}/otherContractManager/getPage`,

  // 其他合同详情
  getOtherContractManagerByCode: `${baseUrl}/otherContractManager/getByCode`,

  // 其他合同更新
  saveToUpdateOtherContractApprove: `${baseUrl}/otherContractApprove/saveToUpdate`,

  // 上传附件
  uploadAttachmentOtherContractApprove: `${baseUrl}/otherContractManager/uploadAttachment`,

  // 其他合同删除
  deleteOtherContractApproveByCode: `${baseUrl}/otherContractManager/deleteByCode`,

  // 其他合约账单查询
  getOtherPayItemDetailPage: `${baseUrl}/otherPayItemDetail/getPage`,

  // 其他合约账单导出
  exportForOtherPayDetail: `${baseUrl}/otherPayItemDetail/exportForOtherPayDetail`,

  // 其他合约 新建提交审批
  submitOtherContractApprove: `${baseUrl}/otherContractApprove/submit`,

  // 其他合约 续租 保存
  saveReletOtherContractApprove: `${baseUrl}/otherContractApprove/saveRelet`,

  // 其他合约 续租 更新
  saveReletToUpdateOtherContractApprove: `${baseUrl}/otherContractApprove/saveReletToUpdate`,

  // 其他合约 续租 提交审批
  submitReletOtherContractApprove: `${baseUrl}/otherContractApprove/submitRelet`,

  // 其他合约 退租 保存
  saveSurrenderOtherContractApprove: `${baseUrl}/otherContractApprove/saveSurrender`,

  // 其他合约 退租 更新
  saveSurrenderToUpdateOtherContractApprove: `${baseUrl}/otherContractApprove/saveSurrenderToUpdate`,

  // 其他合约 退租 提交审批
  submitSurrenderOtherContractApprove: `${baseUrl}/otherContractApprove/submitSurrender`,

  // 其他合约 查看合同历史账单
  getSurrenderOtherContractDetailByContractCode: `${baseUrl}/otherContractApprove/getSurrenderContractDetailByContractCode`,

  // 其他合约 查看合同历史账单
  getListByOtherPayContractCode: `${baseUrl}/otherPayItemDetail/getListByContractCode`,

  // 其他合约作废
  cancelOtherContractApprove: `${baseUrl}/otherContractApprove/cancel`,

  // 工商地址注册管理——分页
  getBusinessAddressPage: `${baseUrl}/businessAddress/getPage`,

  // 工商地址注册管理——迁出
  moveBusinessAddress: `${baseUrl}/businessAddress/move`,

  // 其他合约——账单类型添加
  addOtherBillType: `${baseUrl}/billType/add`,

  // 其他合约——账单类型修改
  updateOtherBillType: `${baseUrl}/billType/update`,

  // 其他合约——账单类型删除
  deleteOtherBillTypeByCodes: `${baseUrl}/billType/deleteByCodes`,

  // 其他合约——账单类型分页
  getOtherBillTypePage: `${baseUrl}/billType/getPage`,

  // 其他合约——账单类型
  getOtherBillTypeList: `${baseUrl}/billType/getList`,

  // 房间账单类型
  getRoomBillPage: `${baseUrl}/contractRoomBill/getPage`,

  // 更新发票状态
  updateRoomInvoiceStatus: `${baseUrl}/contractRoomBill/updateInvoiceStatus`,

  // 批量更新发票状态
  updatePatchRoomInvoiceStatus: `${baseUrl}/contractRoomBill/updatePatch`,

  //合同编号
  getContractId: `${baseUrl}/contractApprove/getContractCode`,

  //其他合同编号
  getOtherContractId: `${baseUrl}/otherContractApprove/getOtherContractCode`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/InvestmentLeasing.js